<template>
	<div class="multi-select">
		<div class="right-check-inner" v-for="(option, optindex) in options" :key="optindex">
			<label class="switch_checkbox_item" >
				<input type="checkbox" :value="localValue[option]" v-model="localValue[option]" @change="changed" @input="changed">
				<div class="switch_checkbox"><span></span></div>
			</label>
			<h3>{{option}}</h3>
		</div>
	</div>
</template>

<script>
export default {
name: "multi-select",
	props: ["options", "value"],
	data() {
		return {
			localValue: this.value || {},
		}
	},
	methods:{
		changed() {
			this.$emit("input", this.localValue)
		}
	},
	mounted() {
	}
}
</script>

<style scoped>

</style>
